import { useEffect } from "react";
import {
  expandViewport,
  isViewportExpanded,
  requestFullscreen,
  swipeBehavior,
  viewport,
} from "@telegram-apps/sdk";
import { setMiniAppHeaderColor } from "@telegram-apps/sdk-react";

export function useTelegramScreen() {
  const fsAvailable = requestFullscreen.isAvailable();
  const isFs = viewport.isFullscreen();
  useEffect(() => {
    const init = async () => {
      if (expandViewport.isAvailable() && !isViewportExpanded()) {
        viewport.expand();
      }

      if (fsAvailable && !isFs) {
        try {
          await viewport.requestFullscreen();
        } catch (e) {
          //
        }
      }

      if (swipeBehavior.isSupported()) {
        if (swipeBehavior.disableVertical.isAvailable()) {
          swipeBehavior.disableVertical();
        }
      }

      if (setMiniAppHeaderColor.isAvailable()) {
        setMiniAppHeaderColor("var(--color-surface)");
      }
    };

    init();
  }, [fsAvailable, isFs]);
}
